import { useState } from "react";
import { IoSettingsOutline } from "react-icons/io5";
import Header from "../CommonComponents/Header";
import Title from "../CommonComponents/Title";
import CommonContainer from "../CommonContainer";
import Emails from "./email";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import EmailDesciption from "./emailDesciption";

const EmailManagement = () => {
    const EMAIL_LIST = 'emailList'
    const EMAIL = 'emailDescription'
    const history = useHistory()
    const [currentPage, setCurrentPage] = useState(EMAIL_LIST) //emailLIst, emailDescription

    const onViewHandler = (emailId) => {
        setCurrentPage(EMAIL)
        history.push(`/sent-emails/${emailId}`)
    }

    const emailList = [
        { id: 1, supplierName: 'sfdfwefwefasdcfsaefefsfsfsfsdfsdfsfsfsf', date: new Date(), subject: 'sdfaeawefsefaefawef', opened: true, replied: true, unsubscribed: true },
        { id: 2, supplierName: 'ABC', date: new Date(), subject: 'Dipole', opened: false, replied: true, unsubscribed: true },
        { id: 3, supplierName: 'ABC', date: new Date(), subject: 'Antares Tech', opened: false, replied: true, unsubscribed: true },
        { id: 4, supplierName: 'ABC', date: new Date(), subject: 'TaTa', opened: true, replied: true, unsubscribed: true },
        { id: 5, supplierName: 'ABC', date: new Date(), subject: 'T20', opened: true, replied: false, unsubscribed: true },
        { id: 6, supplierName: 'ABC', date: new Date(), subject: 'League', opened: true, replied: true, unsubscribed: false },
        { id: 7, supplierName: 'ABC', date: new Date(), subject: 'Ricochet', opened: true, replied: true, unsubscribed: true },
        { id: 8, supplierName: 'ABC', date: new Date(), subject: 'Ricochet', opened: false, replied: false, unsubscribed: false },
        { id: 9, supplierName: 'ABC', date: new Date(), subject: 'Ricochet', opened: true, replied: true, unsubscribed: true },
        { id: 10, supplierName: 'ABC', date: new Date(), subject: 'Ricochet', opened: false, replied: true, unsubscribed: false },
    ]

    return (
        <CommonContainer>
            <Header header='Emailing' />
            <div className="h-75">
                <div className="d-flex justify-content-between pt-4">
                    <Title title='Sent Emails' />
                    <p className="fs-3 fw-bold"><span><IoSettingsOutline color="#65B3E9" size={24} style={{ marginRight: 8 }} /></span>Settings</p>
                </div>
                {currentPage === EMAIL && <EmailDesciption currentPage={currentPage} curPage={EMAIL_LIST} />}
                {currentPage === EMAIL_LIST && <div className=" border p-4 mt-4 h-75 d-flex flex-column row-gap-4" style={{ overflowY: currentPage === EMAIL_LIST ? 'scroll' : '' }}>
                    {emailList?.map((emailDesc) => <Emails onViewHandler={onViewHandler} emailDesc={emailDesc} />)}
                </div>}
                {currentPage === EMAIL_LIST && <div className="d-flex justify-content-end mt-4">
                    <button className="report_button_success">Compose</button>
                </div>}
            </div>

        </CommonContainer>
    )
}

export default EmailManagement;